import { ACCELERATOR, DELIVERY, OPERATOR, PRODUCT_NAME } from '../content/provenance'

export default function AboutPage() {
  return (
    <div className="page-shell py-10">
      {/* The reading measure is capped inside the page gutter rather than
          centred on its own, so the text starts on the same left edge as the
          header and the hero. */}
      <div className="flex max-w-3xl flex-col gap-6">
        <h1 className="text-3xl font-black tracking-tight">About {PRODUCT_NAME}</h1>

        <p className="text-ink-muted">{DELIVERY}</p>

        <section aria-labelledby="how-built">
          <h2 id="how-built" className="text-lg font-bold">
            How it was built
          </h2>
          <p className="mt-2 text-ink-muted">
            {ACCELERATOR} The standards it applies are written out in the repository, one file per
            tool, so the reasoning behind every gate is readable without leaving the codebase.
          </p>
        </section>

        <section aria-labelledby="who">
          <h2 id="who" className="text-lg font-bold">
            Who operates it
          </h2>
          <p className="mt-2 text-ink-muted">
            {PRODUCT_NAME} is built and operated by{' '}
            <a
              href={OPERATOR.url}
              rel="noreferrer"
              className="text-accent-text underline underline-offset-2"
            >
              {OPERATOR.name}
            </a>
            , and delivered as Mission Protoware.
          </p>
        </section>

        <section aria-labelledby="accessibility">
          <h2 id="accessibility" className="text-lg font-bold">
            Accessibility
          </h2>
          <p className="mt-2 text-ink-muted">
            Every route is tested against WCAG 2.1 Level AA, the standard Section 508 incorporates,
            both as a component assertion and as a scan of the rendered page at two viewport sizes.
            Both run on every change.
          </p>
        </section>
      </div>
    </div>
  )
}
